<template>
  <div>
    <div class="block font-medium leading-5 text-gray-700 mt-5">Варианты</div>
    <div class="text-gray-500 text-sm mb-5">
      Нажмите <code class="text-red-500">Enter &#8629;</code>, чтобы добавить еще один вариант.
    </div>

    <ui-form-item v-for="(item, i) in items" :key="i" @keydown.enter.prevent.stop="add(i)">
      <template #before_input>
        <ui-short-toggle class="mt-2 mr-2" :model-value="items[i].isTrue" color="green"
                         @update:modelValue="uncheck(i)"/>
      </template>
      <ui-form-text :placeholder="'Вариант ответа №' + (i + 1)" :value="item.text" :ref="setItemRef"
                    :class="[item.length > 1 ? 'rounded-r-none': '']"
                    @update:modelValue="v=>{set_item_val(i, v)}"/>
      <template #actions>
        <ui-input-action @click="down(i)" :disabled="(i+1)===items.length" class="border-l-0">
          <chevron-down-icon class="h-4 w-4 my-auto text-gray-400"/>
        </ui-input-action>

        <ui-input-action @click="up(i)" :disabled="i===0" class="border-l-0 ">
          <chevron-up-icon class="h-4 w-4 my-auto text-gray-400"/>
        </ui-input-action>

        <ui-input-action @click="del(i)" :disabled="items.length === 1" class="border-l-0 rounded-r-md">
          <x-icon class="h-4 w-4 my-auto text-gray-400"/>
        </ui-input-action>
      </template>
    </ui-form-item>

    <button type="button" class="link text-sm mt-2 ml-12" @click="add()">
      добавить вариант
    </button>

    <ui-alert v-show="noTrueAnswer" class="mt-4 ml-12">
      <p class="text-sm text-yellow-700">Укажите правильный ответ</p>
    </ui-alert>
  </div>
</template>

<script>
import UiInputAction from "@/components/ui/actions/UiInputAction";
import UiShortToggle from "@/components/ui/form/toggles/UiShortToggle";
import {XIcon, ChevronDownIcon, ChevronUpIcon} from '@heroicons/vue/solid'
import UiAlert from "@/components/ui/alert/UiAlert";
import UiFormItem from "@/components/ui/form/UiFormItem";
import UiFormText from "@/components/ui/form/UiFormText";

import {cloneDeep} from "lodash"

export default {
  name: "QuestionSingleSelect",
  components: {UiFormText, UiFormItem, UiAlert, UiShortToggle, UiInputAction, XIcon, ChevronDownIcon, ChevronUpIcon},
  props: {
    index: {type: Number, required: true}
  },
  data() {
    return {
      itemRefs: [],
    }
  },
  computed: {
    noTrueAnswer() {
      return !(this.items.filter(item => item.isTrue).length === 1)
    },
    items() {
      return this.$store.getters['event/questions/props'](this.index)['items']
    }

  },
  methods: {
    setItemRef(el) {
      if (el)
        this.itemRefs.push(el.$el)
    },
    set(key, value) {
      this.$store.dispatch('event/questions/set_prop_key', {index: this.index, key, value})
    },
    uncheck(i) {
      let items = cloneDeep(this.items)
      items.forEach((item, index) => {
        items[index].isTrue = false;
      })
      items[i].isTrue = true
      this.set('items', items)

    },
    // eslint-disable-next-line no-unused-vars
    set_item_val(i, v) {
      let items = cloneDeep(this.items)
      items[i].text = v
      this.set('items', items)
    },

    add(n = null) {
      let items = cloneDeep(this.items)
      if (n === null)
        n = items.length - 1;
      items.splice(n + 1, 0, {text: '', isTrue: false,})
      this.set('items', items)
      setTimeout(() => this.itemRefs[n + 1].focus(), 20);
    },
    del(n) {
      let items = cloneDeep(this.items)
      items.splice(n, 1)
      this.set('items', items)
    },
    up(n) {
      let items = cloneDeep(this.items)
      items.splice(n - 1, 0, items[n])
      items.splice(n + 1, 1)
      this.set('items', items)

    },
    down(n) {
      let items = cloneDeep(this.items)
      items.splice(n + 2, 0, this.props.list[n])
      items.splice(n, 1)
      this.set('items', items)
    },

  },
  beforeUpdate() {
    this.itemRefs = []
  },
  beforeMount() {
    if (!this.items)
      this.set('items', [{text: '', isTrue: false}])
  }

}
</script>

